const light = {
  background: '#fff',
  text: '#414042',

  toggleButton: {
    background: '#C4C4C4',
  },

  aside: {
    background: '#DCECFA',

    input: {
      background: '#F8F8F8',
      text: '#7F8182',
      border: '#D5D5D5',
    },

    tab: {
      text: '#414042',
    },
  },

  footer: {
    text: '#A7A9AB',
  },
}

const dark = {
  background: '#3B3B3B',
  text: '#fff',

  toggleButton: {
    background: '#339CF7',
  },

  aside: {
    background: '#282829',

    input: {
      background: '#313233',
      text: '#D5D5D5',
      border: '#212021',
    },

    tab: {
      text: '#FFFFFF',
    },
  },

  footer: {
    text: '#FFFFFF',
  },
}

export { light, dark }

/*
 dark: {
    page: {
      background: '#3B3B3B',
      text: '#FFFFFF',
    },

    aside: {
      background: '#282829',

      input: {
        background: '#313233',
        border: '#212021',
        text: '#D5D5D5',
      },

      tabs: {
        text: '#D5D5D5',
      },
    },

    toggleButton: {
      background: '#C4C4C4',
    },
  }

  light: {
    page: {
      background: '#fff',
      text: '#414042',
      textSecondary: '#A7A9AB',
    },

    toggleButton: {
      background: '#C4C4C4',
    },

    aside: {
      background: '#DCECFA',

      input: {
        background: '#F8F8F8',
        border: '#D5D5D5',
        text: '#7F8182',
      },
    },
  },
*/
